export const Logout = () => {
    localStorage.removeItem('reestr-expiret');
    localStorage.removeItem('reestr-token');
    localStorage.removeItem('reestr-role');
    window.location.reload('/');
}